<!-- Bouton collaborateur générique -->
<div 
  *ngIf="hasValidName()" 
  class="collaborator-button"
  [class]="buttonClass"
  [class.disabled]="disabled"
  (click)="onCollaboratorClick($event)"
  [style.cursor]="disabled ? 'default' : 'pointer'"
  [attr.aria-label]="'Voir les informations de ' + getFormattedName()"
  role="button"
  tabindex="0"
  (keydown.enter)="onCollaboratorClick($event)"
  (keydown.space)="onCollaboratorClick($event)"
>
  <i 
    *ngIf="showIcon" 
    [class]="iconClass" 
    class="me-1"
    aria-hidden="true"
  ></i>
  <span class="collaborator-name" data-testid="contact-name">{{ getFormattedName() }}</span>
</div>

<!-- Affichage vide si pas de collaborateur valide -->
<div *ngIf="!hasValidName()" class="empty-collaborator">
  <!-- Pas d'icône ni de fond si pas de collaborateur -->
</div>
